import moment from 'moment'

const getAge = (birth) => {
  const years = moment().diff(birth, 'years')
  if (!years) return 0
  return years
}

export default getAge
